import React, { useEffect, useState } from 'react'

// import moment from 'moment'

import SecretaryAuthorizationLayout from 'presentation/secretary/layouts/Authorization'
// import { SearchSurgicalOrders } from 'domain/usecases/surgical-order/search-surgical-orders'
import { SearchSurgicalOrdersNew } from 'domain/usecases/surgical-order/search-surgical-orders-new'
import { SearchCrmoOrderSummary } from 'domain/usecases/surgical-order/search-crmo-order-summary'
import { CrmoOrderListItem } from 'domain/entities/crmo-order-list-item'
// import {
//   OldSurgicalOrderTableFormValues
//   // SurgicalOrderDataGridFormValues,
// } from 'presentation/hospital/components/SurgicalOrderDataGrid'
import { useLocation } from 'react-router-dom'
import { useStores } from 'presentation/hooks/use-stores'
import { observer } from 'mobx-react'
import LoadingModal from 'presentation/shared/components/LoadingModal'
// import { Hospital } from 'domain/entities/hospital-model'
// import { AddSurgicalPendency } from 'domain/usecases/surgical-pendency/add-surgical-pendency'
// import { createAuthorizationContextNew } from 'presentation/hospital/pages/Authorization/context-new'
// import { SurgicalPendency } from 'domain/entities/surgical-pendency'
// import { LoadSurgicalPendencyDocument } from 'domain/usecases/surgical-pendency/load-surgical-pendency-document'
// import { LoadSurgicalPendency } from 'domain/usecases/surgical-pendency/load-surgical-pendency'
// import { FinishSurgicalPendency } from 'domain/usecases/surgical-pendency/finish-surgical-pendency'
import { LoadHealthInsurancePlans } from 'domain/usecases/health-insurance/load-health-insurance-plans'
import { LoadSurgeryCenter } from 'domain/usecases/surgery-center/load-surgery-center'
import { ReorderSurgicalOrder } from 'domain/usecases/surgical-order/reorder-surgery'
import { LoadSurgicalOrder } from 'domain/usecases/surgical-order/load-surgical-order'
import { LoadSurgicalOrderDocument } from 'domain/usecases/surgical-order/load-surgical-order-document'
// import { SurgicalOrderStatus } from 'presentation/shared/components/Timeline/status'
// import { Pagination } from 'service/protocols/api/api-client'
import { PaginationModelNew } from 'domain/entities/pagination-model'
// import translateRole from 'common/utils/getTranslatedRole'
// import { getCrmoTableStatus } from './Functions/getCrmoTableStatus'
// import { useSearchParams } from 'presentation/hooks/use-search-params'
// import { toast } from 'react-toastify'
import moment from 'moment-timezone'
// import { useSearchParams } from 'presentation/hooks/use-search-params'
import { SurgicalOrderStatus } from 'common/enum/surgical-order-status'
import { toast } from 'react-toastify'
import { PasswordMaxDateValidationStatus } from 'common/enum/password-max-date-validation-status'
import { RemakeSurgicalOrder } from 'domain/usecases/surgical-order/remake-surgical-order'
// import { toast } from 'react-toastify'

export type SecretaryAuthorizationProps = {
  // searchSurgicalOrders: SearchSurgicalOrders
  searchCrmoOrderSummary: SearchCrmoOrderSummary
  // addSurgicalPendency: AddSurgicalPendency
  // loadSurgicalPendencyDocument: LoadSurgicalPendencyDocument
  // loadSurgicalPendency: LoadSurgicalPendency
  // finishSurgicalPendency: FinishSurgicalPendency
  loadHealthInsurances: LoadHealthInsurancePlans
  loadSurgeryCenters: LoadSurgeryCenter
  reorderSurgicalOrder: ReorderSurgicalOrder
  loadSurgicalOrder: LoadSurgicalOrder
  loadSurgicalOrderDocument: LoadSurgicalOrderDocument
  remakeSurgicalOrder: RemakeSurgicalOrder
}

const HospitalAuthorization = observer(
  ({
    // searchSurgicalOrders,
    searchCrmoOrderSummary,
    // addSurgicalPendency,
    // loadSurgicalPendencyDocument,
    // finishSurgicalPendency,
    loadHealthInsurances,
    loadSurgeryCenters,
    reorderSurgicalOrder,
    loadSurgicalOrder,
    loadSurgicalOrderDocument,
    remakeSurgicalOrder
  }: SecretaryAuthorizationProps) => {
    const [dataGridData, setDataGridData] = useState<CrmoOrderListItem[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [initialPagination, setInitialPagination] =
      useState<PaginationModelNew>({
        current_page: 1,
        items_per_page: 20000,
        total_items: 20000,
        total_pages: 20000
      })
    const location = useLocation<{
      status?: SurgicalOrderStatus
      start_date: string
      end_date: string
      state?: any
      expired_passwords: boolean
      with_authorized_communication: boolean
      is_package: boolean
    }>()

    const currentHospital = useStores().currentHospital.actualHospital

    const loadSurgicalOrdersNew = async (
      params?: SearchSurgicalOrdersNew.Params
    ) => {
      try {
        setIsLoading(true)

        const surgicalOrders = await searchCrmoOrderSummary.load({
          page_number: params?.page_number || initialPagination.current_page,
          page_size: params?.page_size || initialPagination.items_per_page,
          search: {
            start_date:
              params?.search?.start_date ||
              location.state?.start_date ||
              moment().utc().startOf('day').toISOString(),
            end_date:
              params?.search?.end_date ||
              location.state?.end_date ||
              moment().utc().endOf('day').toISOString(),
            order: params?.search.order || 'ASC',
            status: location.state?.state?.pendency
              ? ''
              : location.state?.status || '',
            surgical_pendency_status:
              params?.search.surgical_pendency_status ||
              location?.state?.state?.surgical_pendency_status ||
              '',
            surgical_pendency_type:
              params?.search.surgical_pendency_type ||
              location?.state?.state?.surgical_pendency_type ||
              '',
            password_max_date_validation_status: location.state
              ?.expired_passwords
              ? PasswordMaxDateValidationStatus.EXPIRED
              : '',
            with_authorized_communication:
              location.state?.with_authorized_communication &&
              location.state?.with_authorized_communication,
            is_package: location.state?.is_package && location.state?.is_package
          }
        })

        const getTechniqueLabel = (technique: string | null | undefined) => {
          if (technique === 'robotic') return 'robótica'
          if (technique === 'conventional') return 'convencional'
          if (technique === 'makoRobot') return 'robô mako'
          if (technique === 'rosaRobot') return 'robô rosa'
          if (technique === 'laser') return 'laser'
          else return 'vídeo'
        }

        setInitialPagination(surgicalOrders.data.page_info)

        setDataGridData(
          surgicalOrders.data?.data?.map((surgicalOrder) => {
            return {
              ...surgicalOrder,
              technique: getTechniqueLabel(surgicalOrder.technique)
            }
          })
        )
      } catch (e: any) {
        toast.error('Ocorreu um erro ao carregar os pedidos cirúrgicos.')
      } finally {
        setIsLoading(false)
      }
    }

    useEffect(() => {
      async function loadData() {
        loadSurgicalOrdersNew()
      }

      loadData()
    }, [currentHospital?.hospital_id])

    // useEffect(() => {
    //   createAuthorizationContextNew({
    //     // addSurgicalPendency,
    //     // addPendency,
    //     // loadSurgicalPendencyDocument,
    //     // finishSurgicalPendency,
    //     initialPaginationState: initialPagination
    //   })
    // }, [dataGridData])

    return (
      <>
        <SecretaryAuthorizationLayout
          data={dataGridData}
          initialValues={{
            status: location.state?.status,
            surgical_pendency_status:
              location.state?.state?.surgical_pendency_status,
            surgical_pendency_type:
              location.state?.state?.surgical_pendency_type,
            expired_passwords: location.state?.expired_passwords,
            with_authorized_communication:
              location.state?.with_authorized_communication,
            is_package: location.state?.is_package
          }}
          filterSubmit={loadSurgicalOrdersNew}
          loadSurgeryCenters={loadSurgeryCenters}
          reorderSurgicalOrder={reorderSurgicalOrder}
          loadHealthInsurances={loadHealthInsurances}
          loadSurgicalOrder={loadSurgicalOrder}
          loadSurgicalOrderDocument={loadSurgicalOrderDocument}
          remakeSurgicalOrder={remakeSurgicalOrder}
        />
        <LoadingModal show={isLoading} />
      </>
    )
  }
)

export default HospitalAuthorization
